var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sendLog } from "./utils/sendLog";
export const getCombinedDependencies = (layerConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f;
    const translations = new Set();
    const fonts = new Map();
    const dependencies = new Set();
    const DEFAULT_MODULE_PRIORITY = -1;
    for (const apexModule of layerConfig.modules) {
        const modulePath = ((_a = apexModule.url) !== null && _a !== void 0 ? _a : "") || `${layerConfig.modulePath}${apexModule.id}/`;
        const moduleConfigPath = `${modulePath.substring(0, modulePath.lastIndexOf("/") + 1)}${apexModule.id}.json`;
        try {
            const moduleConfigResponse = yield fetch(moduleConfigPath);
            if (moduleConfigResponse.ok) {
                const moduleConfig = yield moduleConfigResponse.json();
                const loadPriority = (_c = (_b = apexModule.priority) !== null && _b !== void 0 ? _b : moduleConfig.priority) !== null && _c !== void 0 ? _c : DEFAULT_MODULE_PRIORITY;
                apexModule.priority = loadPriority;
                (_d = moduleConfig.translations) === null || _d === void 0 ? void 0 : _d.forEach((translationContext) => {
                    translations.add(translationContext);
                });
                (_e = moduleConfig.fonts) === null || _e === void 0 ? void 0 : _e.forEach((font) => {
                    var _a;
                    fonts.set(font, Math.min(loadPriority, (_a = fonts.get(font)) !== null && _a !== void 0 ? _a : loadPriority));
                });
                (_f = moduleConfig.dependencies) === null || _f === void 0 ? void 0 : _f.forEach((dependency) => {
                    dependencies.add(dependency);
                });
            }
        }
        catch (error) {
            if (error instanceof Error) {
                const message = `${apexModule.id} module configuration error: ${error.message}`;
                sendLog(message);
                console.error(error);
            }
        }
        if (apexModule.priority === undefined) {
            apexModule.priority = DEFAULT_MODULE_PRIORITY;
        }
    }
    return {
        translations,
        fonts,
        dependencies
    };
});
